/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { position } from 'polished';
import AdvertHandler from 'app/containers/parts/AdvertHandler';
import Modal from 'app/components/commons/Modal';
import Tappable from 'app/components/commons/Tappable';
import t from 'app/utils/translate';

type Props = {
  onClose: () => void,
  zone: string
};

const CloseButton = glamorous.span({
  alignItems: 'center',
  backgroundColor: 'black',
  border: '2px solid currentColor',
  borderRadius: '50%',
  color: 'white',
  display: 'flex',
  height: 24,
  justifyContent: 'center',
  ...position('absolute', '0', '0', null, null),
  transform: 'translate(50%, -50%)',
  width: 24
});

const ModalInner = glamorous.div({
  backgroundColor: 'white',
  position: 'relative'
});

const Tagline = glamorous.div({
  fontSize: '0.8rem',
  padding: 5,
  textAlign: 'center'
});

function AdvertModal({ onClose, zone }: Props) {
  return (
    <Modal bare isOpen size="auto" onCancel={onClose}>
      <ModalInner>
        <Tagline>{t('PlayChip Fantasy is 100% FREE so please read this Ad')}</Tagline>
        <AdvertHandler zone={zone} />
        <Tappable component={CloseButton} onTap={onClose}>
          <span className="ion-close-round" />
        </Tappable>
      </ModalInner>
    </Modal>
  );
}

export default AdvertModal;
